import { useSeoMeta } from "@unhead/react";
import { Link } from "react-router-dom";
import { ArrowLeft, Lock } from "lucide-react";
import { Layout } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ShareButtons } from "@/components/ShareButtons";
import { cn } from "@/lib/utils";
import { useProgress } from "@/hooks/useProgress";

export default function BadgesPage() {
  const { badges, earnedBadges, xp } = useProgress();

  useSeoMeta({
    title: "Badges — BCH School",
    description: "Collect badges as you learn Bitcoin Cash.",
  });

  return (
    <Layout>
      <Button asChild variant="ghost" size="sm" className="mb-4 -ml-2">
        <Link to="/">
          <ArrowLeft className="mr-1 h-4 w-4" /> Home
        </Link>
      </Button>

      <div className="mb-8">
        <h1 className="text-3xl font-extrabold tracking-tight">Badges</h1>
        <p className="mt-1 text-muted-foreground">
          You've unlocked{" "}
          <strong className="text-foreground">
            {earnedBadges.length}
          </strong>{" "}
          of {badges.length} badges. Keep learning to collect them all!
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {badges.map((badge) => (
          <Card
            key={badge.id}
            className={cn(
              "border-2 transition-all",
              badge.unlocked
                ? "border-primary/40 bg-primary/5"
                : "opacity-60",
            )}
          >
            <CardContent className="flex flex-col items-center gap-2 p-6 text-center">
              <div
                className={cn(
                  "flex h-16 w-16 items-center justify-center rounded-full text-3xl",
                  badge.unlocked
                    ? "bg-gradient-to-br from-green-400 to-emerald-600 shadow-md"
                    : "bg-secondary",
                )}
              >
                {badge.unlocked ? (
                  badge.emoji
                ) : (
                  <Lock className="h-6 w-6 text-muted-foreground" />
                )}
              </div>
              <h3 className="font-bold leading-tight">{badge.name}</h3>
              <p className="text-sm text-muted-foreground">
                {badge.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>

      {earnedBadges.length > 0 && (
        <Card className="mt-8 border-2">
          <CardContent className="space-y-4 p-6">
            <div>
              <h2 className="font-bold">Show off your progress</h2>
              <p className="text-sm text-muted-foreground">
                Share your badge collection with the world.
              </p>
            </div>
            <ShareButtons
              text={`I've unlocked ${earnedBadges.length} badge${earnedBadges.length === 1 ? "" : "s"} and earned ${xp} XP learning Bitcoin Cash at BCH School! 🎓⚡`}
            />
          </CardContent>
        </Card>
      )}
    </Layout>
  );
}
